<h1 mat-dialog-title>{{ is_edit ? 'Editar cliente potencial' : 'Creación rápida' }}</h1>

<mat-dialog-content [formGroup]="form">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>Nombre de la persona</mat-label>
          <input type="text" matInput formControlName="full_name" />
        </mat-form-field>
      </div>

      @if (is_edit) {
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>Empresa</mat-label>
            <input type="text" matInput formControlName="company_name" />
          </mat-form-field>
        </div>
      }

      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input type="email" matInput formControlName="email" />
          @if (form.get('email')?.hasError('requiredContact')) {
            <mat-hint>Indica email o teléfono</mat-hint>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>Teléfono</mat-label>
          <input type="text" matInput formControlName="phone" />
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-6">
        <mat-form-field appearance="outline">
          <mat-label>Origen</mat-label>
          <input type="text" matInput [formControl]="originSearchControl" [matAutocomplete]="origin_auto" />
          <mat-autocomplete
            #origin_auto="matAutocomplete"
            [displayWith]="displayFnOrigin"
            (optionSelected)="selectOrigin($event.option.value)"
          >
            @for (origin of filtered_origins; track origin.id) {
              <mat-option [value]="origin">{{ origin.name }}</mat-option>
            }
            @if (create_origin_label) {
              <mat-option [value]="{ __create: true, name: create_origin_label }">Crear «{{ create_origin_label }}»</mat-option>
            }
          </mat-autocomplete>
          <mat-icon matSuffix>expand_more</mat-icon>
        </mat-form-field>
      </div>

      @if (is_edit) {
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>Comercial</mat-label>
            <input type="text" matInput [formControl]="comercialSelectControl" [matAutocomplete]="comercial_select_auto" />
            <mat-autocomplete #comercial_select_auto="matAutocomplete" [displayWith]="displayFnComercial">
              @for (c of available_comercials; track c) {
                <mat-option [value]="c" (click)="selectComercial(c)">{{ c.name + ' ' + c.surnames }}</mat-option>
              }
            </mat-autocomplete>
            <mat-icon matSuffix>expand_more</mat-icon>
          </mat-form-field>
        </div>
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>Facturación anual aprox. (M€)</mat-label>
            <input type="number" matInput formControlName="approximate_company_annual_billing_in_millions" min="0" step="0.1" />
            <mat-hint>En millones de euros</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>Descripción</mat-label>
            <textarea matInput formControlName="description"></textarea>
          </mat-form-field>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" type="button">Cancelar</button>
  <button mat-flat-button color="accent" (click)="submit()" [disabled]="!form.valid || saving" type="button">
    @if (is_edit) {
      Actualizar
    } @else {
      Crear cliente potencial
    }
  </button>
</mat-dialog-actions>
